const unauthorizedModalTemplate = ` <div class="ngdialog-message">
        <div class="row">
          <div class="timeout-head">Your session has been terminated</div>
            <div class="center">
                <button class="timeout-logout-btn" ng-click="ok()">Ok</button>
            </div>
        </div>
    </div>`;

(function (){
    function handler($templateCache, ngDialog, sessionTimeout){
        $templateCache.put('unauthorized_error_modal', unauthorizedModalTemplate);
        const interceptor = new FetchInterceptor();
        let isActive = false;
        return {
            run(){
                interceptor.register({
                    onFailure: async (res) => {
                        if([401].includes(res.status) && !isActive){
                            isActive = true;
                            sessionTimeout.stop();
                            ngDialog.open({
                                template: 'unauthorized_error_modal',
                                className: 'ngdialog-theme-default documentation-dialog',
                                closeByDocument: false,
                                closeByEscape: false,
                                showClose: false,
                                controller: function ($scope, $sessionStorage) {
                                    $scope.ok = () => {
                                        ngDialog.closeAll();
                                        $sessionStorage.$reset();
                                        window.location.hash = '/splash';
                                        window.location.reload();
                                    }
                                }
                            });
                        }
                    }
                });       
            },
            stop(){
                interceptor.unregister();
            }
        }
        
        
    }

    angular.module('myApp').factory('errorHandler', ['$templateCache', 'ngDialog', 'sessionTimeout', handler])
})()

